import React from 'react'
import OurPresenceCard from '../components/OurPresenceCard/OurPresenceCard'
import { useOutletContext } from 'react-router-dom'

const OurPresence = () => {
  const { sectionData } = useOutletContext() || {}
  const members = sectionData

  return (
    <>
      <OurPresenceCard ourPresenceData={members} />
    </>
  )
}

export default OurPresence
